import React from 'react';

const ResultCont = (props) => {

	return (
		<>
			<h2 style={{textAlign: 'center'}}>Results</h2>
			<p>{props.content1}</p>
			<p>{props.content2}</p>
			<p>{props.content3}</p>
			<div className="tempHide"><h5 className="m-0">The Priority Scholarship Date is <strong className="red-letter">December 1st.</strong></h5></div>
			<ul className="cta mb-32"><li><a href="https://www.maryville.edu/about/visit/" rel="_blank" className="btn btn-secondary">Visit Campus</a></li><li><a href="https://www.maryville.edu/admissions/apply/" rel="_blank" class="btn btn-primary">Apply Now (FREE)</a></li><li><a href="https://www.maryville.edu/academics/" rel="_blank" class="btn btn-secondary">Academic Programs</a></li></ul>
			<p className="small" tabindex="0">These scholarships are for first-time freshman looking to take courses on campus full time. Find information on <a href="https://www.maryville.edu/admissions/financial-aid/scholarships" target="_blank" rel="noopener noreferrer">other types of scholarships</a> on our website.</p>

			<div className="responsive-embed"><iframe width="720" height="405" src="https://www.youtube.com/embed/EewDgoMMyCg?si=nJW2VKsY10908b_S" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe></div>
			<div className="startover-container"><button onClick={()=>window.location.reload()}className="startover">Start Over</button></div>
		</>
		);
}

export default ResultCont;